import * as React from "react";
import { Link } from "react-ui";

import { Icon } from "../../Icons/Icon";

import { KeyboardButton, MutedText, Root } from "./ExcelPastePanel.styles";

interface ExcelPastePanelProps {
    templateHref: string;
}

export function ExcelPastePanel(props: ExcelPastePanelProps): JSX.Element {
    return (
        <Root>
            <KeyboardButton>Ctrl</KeyboardButton> <KeyboardButton>C</KeyboardButton> <Icon name={"ArrowCRightIcon"} />{" "}
            <KeyboardButton>Ctrl</KeyboardButton> <KeyboardButton>V</KeyboardButton>
            <MutedText>Можно вставить данные из Excel.</MutedText>
            <Link icon={<Icon name="NetDownloadIcon" />} href={props.templateHref}>
                Скачать шаблон
            </Link>
        </Root>
    );
}
